import { render, staticRenderFns } from "./ibc_round_info.vue?vue&type=template&id=639ae091&"
import script from "./ibc_round_info.vue?vue&type=script&lang=js&"
export * from "./ibc_round_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports